import { render, staticRenderFns } from "./summary-section.vue?vue&type=template&id=4658c192&scoped=true&"
import script from "./summary-section.vue?vue&type=script&lang=js&"
export * from "./summary-section.vue?vue&type=script&lang=js&"
import style0 from "./summary-section.vue?vue&type=style&index=0&id=4658c192&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4658c192",
  null
  
)

export default component.exports